/**
 * bell.ts — Categoría "Belleza" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_bell",
  skuPrefix: "BEL",
  categoria: "Belleza",
} as const;

export const cat_bell_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Labial Mate MAC",
    marca: "MAC Cosmetics",
    modelo: "Ruby Woo",
    origen: "Canadá",
    costo: 52500,
    precio: 79900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "unidad",
    ubicacionFisica: "Góndola BE1",
    proveedor: "MAC Cosmetics Colombia",
    vencimientoMeses: 24,
    pesoNeto: "3g",
    descripcionLarga:
      "Labial mate icúnico color Ruby Woo, rojo vibrante de larga duración con fórmula matte hidratante.",
    especificaciones: [
      { clave: "Acabado", valor: "Mate" },
      { clave: "Tono", valor: "Ruby Woo" },
    ],
    imageKeywords: ["lipstick", "mac-lipstick", "red-lipstick"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Base Líquida Fenty Beauty",
    marca: "Fenty Beauty",
    modelo: "Pro Filt'r 310",
    origen: "EE.UU.",
    costo: 125000,
    precio: 189000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Góndola BE1",
    proveedor: "Fenty Beauty LATAM",
    vencimientoMeses: 24,
    pesoNeto: "32ml",
    descripcionLarga:
      "Base líquida mate de larga duración 24h, control de brillo. 50 tonos inclusivos. Tono 310 medio cálido.",
    especificaciones: [
      { clave: "Acabado", valor: "Mate" },
      { clave: "Duración", valor: "24h" },
    ],
    imageKeywords: ["foundation", "fenty-beauty", "liquid-foundation"],
    color: "bg-amber-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Máscara Pestañas Maybelline",
    marca: "Maybelline",
    modelo: "Sky High",
    origen: "EE.UU.",
    costo: 38500,
    precio: 58900,
    stock: 55,
    stockMinimo: 12,
    stockMaximo: 110,
    unidad: "unidad",
    ubicacionFisica: "Góndola BE1",
    proveedor: "L'Oréal Colombia",
    vencimientoMeses: 18,
    pesoNeto: "7.2ml",
    descripcionLarga:
      "Máscara Sky High para pestañas hasta el infinito. Fórmula con bambú flexible, largo y volumen sin grumos.",
    especificaciones: [
      { clave: "Color", valor: "Negro" },
      { clave: "Efecto", valor: "Largo + volumen" },
    ],
    imageKeywords: ["mascara", "maybelline", "eye-makeup"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Paleta Sombras Urban Decay",
    marca: "Urban Decay",
    modelo: "Naked Heat",
    origen: "EE.UU.",
    costo: 245000,
    precio: 379000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Góndola BE2",
    proveedor: "Urban Decay Colombia",
    vencimientoMeses: 36,
    descripcionLarga:
      "Paleta 12 sombras en tonos ámbar, cobre y terracota. Acabados mate y metálicos. Pigmentos de alta durabilidad.",
    especificaciones: [
      { clave: "Sombras", valor: "12" },
      { clave: "Estilo", valor: "Warm amber" },
    ],
    imageKeywords: ["eyeshadow-palette", "urban-decay", "makeup-palette"],
    color: "bg-orange-700",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Crema Hidratante Facial",
    marca: "La Roche-Posay",
    modelo: "Toleriane Double Repair",
    origen: "Francia",
    costo: 78500,
    precio: 119000,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "tarro",
    ubicacionFisica: "Estante BE3, skincare",
    proveedor: "L'Oréal Colombia",
    vencimientoMeses: 24,
    pesoNeto: "75ml",
    descripcionLarga:
      "Crema hidratante restauradora con prebióticos, ceramidas y niacinamida. Reduce irritación y refuerza barrera cutánea.",
    especificaciones: [
      { clave: "Volumen", valor: "75ml" },
      { clave: "Tipo piel", valor: "Sensible" },
    ],
    imageKeywords: ["moisturizer", "face-cream", "la-roche"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Perfume Mujer Chanel",
    marca: "Chanel",
    modelo: "Coco Mademoiselle EDP",
    origen: "Francia",
    costo: 485000,
    precio: 749000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "unidad",
    ubicacionFisica: "Vitrina BE4",
    proveedor: "Chanel Colombia",
    vencimientoMeses: 60,
    pesoNeto: "100ml",
    descripcionLarga:
      "Perfume EDP Coco Mademoiselle 100ml. Fragancia chipre floral con notas de naranja, rosa y pachuli. Icono de elegancia.",
    especificaciones: [
      { clave: "Volumen", valor: "100ml" },
      { clave: "Familia", valor: "Chipre floral" },
    ],
    imageKeywords: ["perfume", "chanel-perfume", "womens-fragrance"],
    color: "bg-pink-300",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Perfume Hombre CK",
    marca: "Calvin Klein",
    modelo: "CK One EDT",
    origen: "Francia",
    costo: 225000,
    precio: 349000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Vitrina BE4",
    proveedor: "Calvin Klein Colombia",
    vencimientoMeses: 60,
    pesoNeto: "200ml",
    descripcionLarga:
      "EDT CK One unisex 200ml. Fragancia cítrica fresca con bergamota, mandarina y té verde. Icónica desde 1994.",
    especificaciones: [
      { clave: "Volumen", valor: "200ml" },
      { clave: "Familia", valor: "Cítrica fresca" },
    ],
    imageKeywords: ["mens-perfume", "calvin-klein", "cologne"],
    color: "bg-slate-200",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Esmalte Uñas OPI",
    marca: "OPI",
    modelo: "Big Apple Red",
    origen: "EE.UU.",
    costo: 32500,
    precio: 49900,
    stock: 65,
    stockMinimo: 15,
    stockMaximo: 130,
    unidad: "unidad",
    ubicacionFisica: "Góndola BE1",
    proveedor: "OPI Colombia",
    vencimientoMeses: 36,
    pesoNeto: "15ml",
    descripcionLarga:
      "Esmalte clásico OPI tono Big Apple Red. Fórmula 7-free, alta cubrición, brillo duradero hasta 10 días.",
    especificaciones: [
      { clave: "Volumen", valor: "15ml" },
      { clave: "Tono", valor: "Rojo clásico" },
    ],
    imageKeywords: ["nail-polish", "opi-nail", "red-polish"],
    color: "bg-red-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Plancha de Cabello",
    marca: "GHD",
    modelo: "Platinum+",
    origen: "Reino Unido",
    costo: 585000,
    precio: 899000,
    stock: 12,
    stockMinimo: 3,
    stockMaximo: 24,
    unidad: "unidad",
    ubicacionFisica: "Vitrina BE5",
    proveedor: "GHD Colombia",
    garantia: "3 años",
    material: "Cerámica",
    colorProducto: "Negro",
    dimensiones: "25.5cm",
    descripcionLarga:
      "Plancha profesional GHD Platinum+ con tecnología Ultra-Zone y sensor predictivo. Protege y deja cabello brillante.",
    especificaciones: [
      { clave: "Temperatura", valor: "185°C" },
      { clave: "Tecnología", valor: "Predictiva" },
    ],
    imageKeywords: ["hair-straightener", "ghd", "hair-iron"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Secador Profesional Dyson",
    marca: "Dyson",
    modelo: "Supersonic HD07",
    origen: "Singapur",
    costo: 1250000,
    precio: 1890000,
    stock: 6,
    stockMinimo: 2,
    stockMaximo: 12,
    unidad: "unidad",
    ubicacionFisica: "Vitrina BE5",
    proveedor: "Dyson Colombia",
    garantia: "2 años",
    material: "Plástico ABS",
    colorProducto: "Fucsia",
    descripcionLarga:
      "Secador Dyson Supersonic con motor digital V9, ingeniería aerodinámica. Protege el cabello del daño térmico.",
    especificaciones: [
      { clave: "Potencia", valor: "1600W" },
      { clave: "Incluye", valor: "5 boquillas" },
    ],
    imageKeywords: ["hair-dryer", "dyson-supersonic", "professional-dryer"],
    color: "bg-pink-500",
    shape: "square",
    gastoMargen: "ambicioso",
  }),
];
